export default class Particle {
  constructor(x, y, directionX, directionY, size, color, canvas, context) {
    this.x = x;
    this.y = y;
    this.directionX = directionX;
    this.directionY = directionY;
    this.size = size;
    this.color = color;
    this.canvas = canvas;
    this.context = context;
  }

  draw() {
    this.context.beginPath();
    this.context.arc(this.x, this.y, this.size, 0, Math.PI * 2, false);
    this.context.lineWidth = 4;
    this.context.strokeStyle = 'white';
    this.context.stroke();
  }

  update() {
    if(this.x + this.size > this.canvas.width || this.x - this.size < 0) {
      this.directionX = -this.directionX;
    }
    if(this.y + this.size > this.canvas.height ||this.y - this.size < 0) {
      this.directionY = -this.directionY;
    }
    this.x += this.directionX;
    this.y += this.directionY;
    
    this.draw();
  }
}